"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("../../styled-5e32dba1.js");require("../../extends-7fef164d.js");require("../../createTheme-fa1f72a4.js");require("../../index-90dcd9ec.js");require("../../_commonjsHelpers-6763f629.js");require("../../index-800f129a.js");require("react");require("../../emotion-react.browser.esm-981c4409.js");require("../../hoist-non-react-statics.cjs-081bcdb8.js");require("react/jsx-runtime");require("../../getDisplayName-a38893db.js");const r=e.styled("div")`
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;

  & > * {
    position: relative;
    &:not(:first-child) {
      margin-left: -4px;
    }
  }
`,i=e.styled("div")`
  && {
    margin-left: 4px;
  }
`;exports.CountWrapper=i;exports.Wrapper=r;
